import { render, staticRenderFns } from "./topFlotilla.vue?vue&type=template&id=5a765d12&scoped=true"
import script from "./topFlotilla.vue?vue&type=script&lang=js"
export * from "./topFlotilla.vue?vue&type=script&lang=js"
import style0 from "./topFlotilla.vue?vue&type=style&index=0&id=5a765d12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a765d12",
  null
  
)

export default component.exports